import React, { useState, useContext, useEffect } from 'react';
import EditView from './user-edit/EditView';
import ListView from './user-list/ListView';
import LocaleContext from '../../constants/localization';

const ManageUsersView = ({ id }) => {
  const LS = useContext(LocaleContext);

  useEffect(() => {
    if (id) {
      setSelectView(false);
      setSelectedGroup(id);
    }
  }, []);

  const [selectView, setSelectView] = useState(true);
  const [selectedGroup, setSelectedGroup] = useState('');

  return (
    <div className="manage-users">
      <h1>{LS.manageUsers.userManagement}</h1>
      {selectView ? (
        <ListView
          setSelectedGroup={setSelectedGroup}
          setSelectView={setSelectView}
        />
      ) : (
        <EditView
          selectedGroup={selectedGroup}
          handleCancel={() => setSelectView(true)}
        />
      )}
    </div>
  );
};

export default ManageUsersView;
